// extracted by mini-css-extract-plugin
export default {"faq":"FAQPage_faq__VOCMI","container":"FAQPage_container__E+WPU","title":"FAQPage_title__U02t+","subTitle":"FAQPage_subTitle__lI-AW","text":"FAQPage_text__v6ni6"};